import type { OutilFpeDTO } from '@/features/api/extranet/dto/Demande/OUTILFPE'
import { type TypeContextCourant } from '@/features/auth/context-app'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const BordereauRecapitulatifCommandeCarte = 'BordereauRecapitulatifCommandeCarte' as const
export const RecapitulatifVirementBancaire = 'RecapitulatifVirementBancaire' as const
export const FactureEntreprise = 'FactureEntreprise' as const
export const CopieFacture = 'CopieFacture' as const
export const AttestationEmployeur = 'AttestationEmployeur' as const

const AllNatures = [
  'Autre',
  CopieFacture,
  BordereauRecapitulatifCommandeCarte,
  RecapitulatifVirementBancaire,
  FactureEntreprise,
  AttestationEmployeur,
] as const
type AllNatures = (typeof AllNatures)[number]

export const getNaturesFichiersOutilFpe: NaturesFichiersDemandeCallback<OutilFpeDTO> = (
  demande: OutilFpeDTO,
  _typeContext: TypeContextCourant,
) => {
  const nombreFichiersMinimum: { [property in AllNatures]?: number } = {}
  const nombreFichiersMaximum: { [property in AllNatures]?: number } = {}

  let obligatoires: Set<AllNatures> = new Set()
  let facultatifs: Set<AllNatures> = new Set(['Autre', FactureEntreprise])
  let facultatifsDefaut: Set<AllNatures> = new Set([FactureEntreprise])

  switch (demande.sousDispositif) {
    case 'BadgeAero':
      obligatoires.add(CopieFacture)
      obligatoires.add(FactureEntreprise)
      facultatifs.add(AttestationEmployeur)
      break
    case 'CarteBtp': {
      obligatoires.add(BordereauRecapitulatifCommandeCarte)
      obligatoires.add(RecapitulatifVirementBancaire)
      obligatoires.add(FactureEntreprise)
      break
    }
    case 'CarteChrono': {
      obligatoires.add(CopieFacture)
      obligatoires.add(FactureEntreprise)
      facultatifs.add(AttestationEmployeur)
      break
    }
  }

  // PRT-1278 : simplification administrative
  if (demande.avecSimplificationAdministrative === 'Fichier') {
    facultatifsDefaut = new Set([...obligatoires, ...facultatifsDefaut])
    facultatifsDefaut.delete(FactureEntreprise)
    facultatifs = new Set([...facultatifsDefaut, ...facultatifs])
    obligatoires = new Set([FactureEntreprise])
  }

  return {
    obligatoires: [...obligatoires],
    facultatifs: [...facultatifs],
    facultatifsDefaut: [...facultatifsDefaut],
    /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
    nombreFichiersMaximum: nombreFichiersMaximum,
    nombreFichiersMinimum: nombreFichiersMinimum,
  }
}
